import axios from "axios";
import Apis from "./apis";

let refreshPromise = null;

/* ------------------ Token helpers ------------------ */

const isTokenExpired = () => {
  const expiresAt = localStorage.getItem("accessTokenExpiresAt");
  const accessToken = localStorage.getItem("accessToken");

  if (accessToken && !expiresAt) {
    localStorage.clear();
    window.location.replace("/login");
    return true;
  }

  // refresh 1 minute before expiry
  return Date.now() > Number(expiresAt) - 60_000;
};

const logout = () => {
  localStorage.clear();
  // window.location.replace("/login");
  window.location.replace('https://www.pricingculture.com/collectible-assets-terminal')
};

/* ------------------ Axios instance ------------------ */

const axiosInstance = axios.create({
  baseURL: "https://schedulerapi.pricingculture.com/holdings/",
});

/* ------------------ REQUEST INTERCEPTOR ------------------ */

axiosInstance.interceptors.request.use(
  async (config) => {
    let accessToken = localStorage.getItem("accessToken");
    const email = localStorage.getItem("email");

    // 🔁 1️⃣ Refresh BEFORE request if token expired
    if (isTokenExpired()) {
      try {
        if (!refreshPromise) {
            const apis = new Apis();
          refreshPromise = await apis.refreshSession(email).finally(() => {
            refreshPromise = null;
          });
        }

        const { accessToken: newToken } = await refreshPromise;
        accessToken = newToken;

        localStorage.setItem("accessToken", newToken);
        // accessTokenExpiresAt must be set inside refreshSession
      } catch (err) {
        logout();
        return Promise.reject(err);
      }
    }

    // Attach token
    config.headers = {
      ...(config.headers || {}),
      access_token: accessToken,
    };

    return config;
  },
  (error) => Promise.reject(error)
);

/* ------------------ RESPONSE INTERCEPTOR ------------------ */

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const status = error?.response?.status;
    const email = localStorage.getItem("email");

    // 🔁 2️⃣ Retry once on 401
    if (status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const apis = new Apis();

        const { accessToken: newToken } = await apis.refreshSession(email);

        localStorage.setItem("accessToken", newToken);

        originalRequest.headers = {
          ...(originalRequest.headers || {}),
          access_token: newToken,
        };

        return axiosInstance(originalRequest);
      } catch (err) {
        logout();
        return Promise.reject(err);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
